import React from 'react'

const process = [
  {
    title: 'Market Structure Analysis',
    text: 'Analyze liquidity, order flow, and structural behavior across fragmented global markets.'
  },
  {
    title: 'Hypothesis Development',
    text: 'Formulate research hypotheses around persistent inefficiencies and measurable alpha opportunities.'
  },
  {
    title: 'Statistical Validation',
    text: 'Run robust tests with out-of-sample analysis, regime segmentation, and stability diagnostics.'
  },
  {
    title: 'Strategy Simulation',
    text: 'Simulate strategies under realistic market constraints and transaction cost assumptions.'
  },
  {
    title: 'Portfolio Risk Integration',
    text: 'Integrate exposure controls, stress tests, and portfolio-level risk governance frameworks.'
  },
  {
    title: 'Execution Optimization',
    text: 'Refine execution logic to reduce slippage, improve fills, and preserve statistical edge in production.'
  },
]

const ResearchProcess = () => {
  return (
    <div id='research-process' className='section-grid pt-10 pb-32 lg:pt-10 lg:pb-36 xl:pt-10 xl:pb-40 px-5 md:px-8 flex flex-col justify-center items-center bg-[#fafafa]'>
      <div className='w-full max-w-[1100px]'>
        <hr className='mb-10 border-0 h-[1px] bg-[#eeeeee]' />
        <h1 className='text-primary-dark metro-semi mt-[10px] mb-6 text-[34px]'>Research Methodology</h1>
        <p className='metro mt-[10px] mb-12 max-w-3xl text-[17px] leading-relaxed text-secondary-light md:text-[18px]'>Our research process develops systematic models to identify structural inefficiencies in financial markets.</p>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-12'>
          {process.map((item, index) => (
            <div key={item.title} className='bg-white p-6 border-l-2 border-[#26bfb5] lg:col-span-6'>
              <h2 className='metro-semi text-[24px] text-secondary mb-3'>{`${index + 1}. ${item.title}`}</h2>
              <p className='metro text-secondary-light text-[17px]'>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ResearchProcess
